// extracted by mini-css-extract-plugin
module.exports = {"column":"column_column__3tHR4","rows":"column_rows__3Uauu"};